import { CSSProperties } from 'react'

export const s = {
  block: {
    letterSpacing: '0.005em',
    padding: '12px',
    boxShadow: 'none',
    backgroundColor: '#fafafa',
    border: '1px solid #BFBFBF',
  } as CSSProperties,
  blockTitle: {
    lineHeight: '24px',
    fontWeight: 600,
    margin: 0,
  } as CSSProperties,
  blockLink: {
    color: '#AF231C',
    fontWeight: 500,
    fontSize: '12px',
    padding: 0,
  } as CSSProperties,
  unableBlock: {
    filter: 'invert(80%) sepia(17%) saturate(13%) hue-rotate(350deg) brightness(100%) contrast(93%)',
  } as CSSProperties,
  fileList: {
    alignItems: 'center',
  } as CSSProperties,
  fileListItem: {
    padding: '4px 64px 4px 0',
  } as CSSProperties,
  fileListIcon: {
    minWidth: '12px',
  } as CSSProperties,
  fileListName: {
    marginLeft: '4px',
    color: '#AF231C',
    fontWeight: 600,
  } as CSSProperties,
  fileListDownloadIcon: {
    position: 'absolute',
    right: '6px',
    top: '6px',
  } as CSSProperties,
  dialog: {
    borderRadius: '8px',
  } as CSSProperties,
  dialogTitle: {
    fontWeight: 600,
    padding: '24px 24px 12px',
  } as CSSProperties,
  layoutName: {
    fontSize: '16px',
    fontWeight: 600,
    margin: 0,
  } as CSSProperties,
}
